// @flow
import React from 'react'
import TmPreview from './TmPreview'
import type { Crop, Image, PersistedImage } from '../../types'

type Props = {|
  title: string,
  description: string,
  url: string,
  image: ?Image | ?PersistedImage,
  imageCrop: ?Crop
|}

export default function TmPreviewMulti(props: Props) {
  const { title, description, url, image, imageCrop } = props

  return (
    <TmPreview
      title={title}
      description={description}
      image={image}
      imageCrop={imageCrop}
      url={url}
    />
  )
}
